import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import ReportReducer from '../reducers/reports';
import { ActionFromPayloadMap } from '../config/types';
import { ReportExport } from '../config/types/reports';

export type ReportStateType = {
  panelIsOpen: boolean,
  reportExports: ReportExport[] | undefined,
};

export type ReportActionPayloadMap = {
  SET_REPORT_EXPORTS: ReportExport[];
  UPDATE_REPORT_EXPORT: ReportExport;
  SET_PANEL_IS_OPEN: boolean;
};

export type ReportAction = ActionFromPayloadMap<ReportActionPayloadMap>;

const initialState: ReportStateType = {
  panelIsOpen: false,
  reportExports: undefined,
};

export const ReportContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<ReportAction>,
});

export const useReport = (): [ReportStateType, React.Dispatch<ReportAction>] => {
  const { state, dispatch } = useContext(ReportContext);
  return [state, dispatch];
};

export const ReportProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(ReportReducer, initialState);

  return (
    <ReportContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </ReportContext.Provider>
  );
};
